var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocumentsTabWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.21 1l5 5h-4a1 1 0 01-1-1V1z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21 14.635c0-.483.393-.875.876-.875h9.125a1 1 0 011 1v.5a.25.25 0 01-.25.25H4.086a.875.875 0 01-.875-.875zM3.21 9.755c0-.483.393-.875.876-.875h9.125a1 1 0 011 1v.5a.25.25 0 01-.25.25H4.086a.875.875 0 01-.875-.875zM3.21 4.875c0-.483.393-.875.876-.875h4.207c.28 0 .508.228.508.508v1.106a.136.136 0 01-.136.136h-4.58a.875.875 0 01-.874-.875z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.96 6.328V18c0 .69-.559 1.25-1.25 1.25H2.21c-.69 0-1.25-.56-1.25-1.25V2c0-.69.56-1.25 1.25-1.25h9.172c.332 0 .65.132.884.366l4.329 4.329c.234.234.366.552.366.883z",
    stroke: "#FFF",
    strokeWidth: 1.5
  })));
}
export default SvgIconDocumentsTabWhite;